import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { HTML } from '@antv/g';
import { kebabCase } from '../utils/string';
import { subObject } from '../utils/helper';
function dom(tag, children, style) {
  return "<".concat(tag, " style=\"").concat(Object.entries(style).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return "".concat(kebabCase(key), ":").concat(value);
  }).join(';'), "\">").concat(children, "</").concat(tag, ">");
}
var defaultTipStyle = {
  backgroundColor: 'rgba(0,0,0,0.75)',
  color: '#fff',
  width: 'max-content',
  padding: '1px 4px',
  fontSize: '12px',
  borderRadius: '2.5px',
  boxShadow: '0 3px 6px -4px rgba(0,0,0,0.12), 0 6px 16px 0 rgba(0,0,0,0.08), 0 9px 28px 8px rgba(0,0,0,0.05)'
};
function isTipText(element) {
  if (element.nodeName !== 'text') return false;
  if (element.isOverflowing()) return true;
  return false;
}
export function Poptip(_a) {
  var _a$offsetX = _a.offsetX,
    offsetX = _a$offsetX === void 0 ? 8 : _a$offsetX,
    _a$offsetY = _a.offsetY,
    offsetY = _a$offsetY === void 0 ? 8 : _a$offsetY,
    style = __rest(_a, ["offsetX", "offsetY"]);
  return function (context) {
    var container = context.container;
    var _container$getBounds$ = _slicedToArray(container.getBounds().min, 2),
      x0 = _container$getBounds$[0],
      y0 = _container$getBounds$[1];
    var tipStyle = subObject(style, 'tip');
    var tips = new Set();
    var pointerover = function pointerover(e) {
      var target = e.target;
      if (!isTipText(target)) {
        e.stopPropagation();
        return;
      }
      var mouseX = e.offsetX,
        mouseY = e.offsetY;
      var x = mouseX + offsetX - x0;
      var y = mouseY + offsetY - y0;
      if (target.tip) {
        target.tip.style.x = x;
        target.tip.style.y = y;
        return;
      }
      var text = target.style.text;
      var tipELement = new HTML({
        className: 'poptip',
        style: {
          innerHTML: dom('div', text, Object.assign(Object.assign({}, defaultTipStyle), tipStyle)),
          x: x,
          y: y
        }
      });
      container.appendChild(tipELement);
      target.tip = tipELement;
      tips.add(tipELement);
    };
    var pointerout = function pointerout(e) {
      var target = e.target;
      if (!isTipText(target)) {
        e.stopPropagation();
        return;
      }
      if (!target.tip) return;
      target.tip.remove();
      target.tip = null;
      tips.delete(target.tip);
    };
    container.addEventListener('pointerover', pointerover);
    container.addEventListener('pointerout', pointerout);
    return function () {
      container.removeEventListener('pointerover', pointerover);
      container.removeEventListener('pointerout', pointerout);
      tips.forEach(function (tip) {
        return tip.remove();
      });
    };
  };
}